import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var ToggleRight = createReactComponent("ToggleRight", ["svg", defaultAttributes, [["rect", {
  x: "1",
  y: "5",
  width: "22",
  height: "14",
  rx: "7",
  ry: "7",
  key: "vu0vnq"
}], ["circle", {
  cx: "16",
  cy: "12",
  r: "3",
  key: "1h4jq7"
}]]]);
export default ToggleRight;